import React from "react";
import { LazyLoadImage } from "web/react/components/lazy-load-image/lazy-load-image";
import { EditorialDetailObject, EditorialDetails } from "web/react/emo/editorial-details";
import { useDomViewport } from "web/react/hooks/use-dom-viewport/use-dom-viewport";
import * as styles from "./hero-story.css";

interface HeroStoryProps {
    editorialDetails: EditorialDetailObject;
    desktopImage: string;
    mobileImage: string;
    lazy?: boolean;
    alt?: string;
}
export function HeroStory({
    editorialDetails,
    desktopImage,
    mobileImage,
    lazy = true,
    alt,
}: HeroStoryProps): React.ReactElement {
    const { isMobileViewport } = useDomViewport();
    const imageSrc = isMobileViewport ? mobileImage : desktopImage;
    return (
        <section className={styles.wrapper}>
            {lazy ? (
                <LazyLoadImage src={imageSrc} className={styles.image} alt={alt} />
            ) : (
                <img src={imageSrc} className={styles.image} alt={alt} />
            )}
            <div className={styles.editorialDetails}>
                <EditorialDetails details={editorialDetails} />
            </div>
        </section>
    );
}
